import { createFileRoute } from '@tanstack/react-router';
import { makeTableSearchValidator } from '../lib/table-filter.js';
import { AccountsPage } from './accounts.js';

export const Route = createFileRoute('/$workspaceSlug/accounts')({
  component: AccountsPage,
  validateSearch: makeTableSearchValidator({ view: 'uuid' }),
});
